const customStylesInfo = {
  container: (provided: any) => ({
    ...provided,
    width: "71%",
  }),

  control: (provided: any, state: any) => ({
    ...provided,
    background: "#fff",
    textAlign: "left",
    fontSize: "10px",
    fontWeight: "normal",
    minHeight: "15px",
    height: "15px",
    margin: "3.5px 0",
    border: "1px dotted black",
    borderRadius: "none",
    borderBottomRightRadius: 10,
    borderColor: state.selectProps.error ? "red" : "#fff",
    boxShadow: state.isFocused ? null : null,
  }),

  valueContainer: (provided: any, state: any) => ({
    ...provided,
    height: "15px",
    padding: "0px"
  }),

  input: (provided: any, state: any) => ({
    ...provided,
    margin: "0px",
  }),

  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    display: "none"
  }),

  option: (provided: any, state: any) => ({
    ...provided,
    textAlign: "left"
  }),
};

export default customStylesInfo;
